var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3301 20.6665C18.5392 20.6665 20.3301 18.8756 20.3301 16.6665C20.3301 14.4574 18.5392 12.6665 16.3301 12.6665C14.1209 12.6665 12.3301 14.4574 12.3301 16.6665C12.3301 18.8756 14.1209 20.6665 16.3301 20.6665Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 17.8406V15.4939C2.99609 14.1072 4.12943 12.9606 5.52943 12.9606C7.94276 12.9606 8.92943 11.2539 7.71609 9.16057C7.02276 7.96057 7.43609 6.40057 8.64943 5.70723L10.9561 4.38723C12.0094 3.76057 13.3694 4.1339 13.9961 5.18723L14.1428 5.44057C15.3428 7.5339 17.3161 7.5339 18.5294 5.44057L18.6761 5.18723C19.3028 4.1339 20.6628 3.76057 21.7161 4.38723L24.0228 5.70723C25.2361 6.40057 25.6494 7.96057 24.9561 9.16057C23.7428 11.2539 24.7294 12.9606 27.1428 12.9606C28.5294 12.9606 29.6761 14.0939 29.6761 15.4939V17.8406C29.6761 19.2272 28.5428 20.3739 27.1428 20.3739C24.7294 20.3739 23.7428 22.0806 24.9561 24.1739C25.6494 25.3872 25.2361 26.9339 24.0228 27.6272L21.7161 28.9472C20.6628 29.5739 19.3028 29.2006 18.6761 28.1472L18.5294 27.8939C17.3294 25.8006 15.3561 25.8006 14.1428 27.8939L13.9961 28.1472C13.3694 29.2006 12.0094 29.5739 10.9561 28.9472L8.64943 27.6272C7.43609 26.9339 7.02276 25.3739 7.71609 24.1739C8.92943 22.0806 7.94276 20.3739 5.52943 20.3739C4.12943 20.3739 2.99609 19.2272 2.99609 17.8406Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/Setting_icon.38aeb472f3dd75c28325684cd9b20583.svg";
export { ForwardRef as ReactComponent };